import styled, { keyframes } from "styled-components";

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const BookingSection = styled.section`
  background: #faf8f5;
  padding: 100px 24px;
  position: relative;
  z-index: 10;
`;

const BookingContainer = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 4px;
  padding: 50px 60px;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.1);
  animation: ${fadeInUp} 0.8s ease forwards;

  @media (max-width: 768px) {
    padding: 32px 24px;
    margin-top: -40px;
  }
`;

const BookingTitle = styled.h2`
  font-size: 13px;
  font-weight: 600;
  color: #c9a86c;
  margin-bottom: 8px;
  text-align: center;
  letter-spacing: 3px;
  text-transform: uppercase;
`;

const BookingSubtitle = styled.p`
  font-size: 32px;
  font-weight: 300;
  color: #1a1a1a;
  margin-bottom: 40px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

const OtaList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const OtaLink = styled.a`
  border: 1px solid #e5e1dc;
  border-radius: 8px;
  padding: 18px;
  text-decoration: none;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  gap: 14px;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
    border-color: #c9a86c;
  }
`;

const OtaLogo = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
  border-radius: 6px;
  background: #fff;
`;

const OtaMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const OtaName = styled.span`
  font-weight: 600;
`;

const OtaText = styled.span`
  color: #8b7355;
  font-size: 13px;
`;

const QuickInfo = styled.div`
  margin-top: 50px;
  padding-top: 50px;
  border-top: 1px solid #e5e1dc;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  text-align: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

const InfoItem = styled.div`
  h4 {
    font-size: 42px;
    font-weight: 300;
    color: #1a1a1a;
    margin-bottom: 8px;

    span {
      color: #c9a86c;
    }
  }

  p {
    font-size: 13px;
    color: #8b7355;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
`;

const BookingWidget = () => {
  const hotelKeyword =
    "Hebe Hotel, Hostel, & Hospitality Network in Bogor";
  const hotelQuery = encodeURIComponent(hotelKeyword);
  const otaLinks = [
    {
      name: "Agoda",
      logo: "https://logo.clearbit.com/agoda.com",
      href: `https://www.agoda.com/search?textToSearch=${hotelQuery}`,
    },
    {
      name: "Trip.com",
      logo: "https://logo.clearbit.com/trip.com",
      href: `https://www.trip.com/hotels/list?keyword=${hotelQuery}`,
    },
    {
      name: "Booking.com",
      logo: "https://logo.clearbit.com/booking.com",
      href: `https://www.booking.com/searchresults.html?ss=${hotelQuery}`,
    },
  ];

  return (
    <BookingSection id="booking">
      <BookingContainer>
        <BookingTitle>Book Your Stay</BookingTitle>
        <BookingSubtitle>Book via our connected Online Travel Agents</BookingSubtitle>

        {/* Legacy booking form is intentionally disabled for now.
            Keep this section for future in-site booking feature rollout. */}

        <OtaList>
          {otaLinks.map((ota) => (
            <OtaLink
              key={ota.name}
              href={ota.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <OtaLogo src={ota.logo} alt={`${ota.name} logo`} />
              <OtaMeta>
                <OtaName>{ota.name}</OtaName>
                <OtaText>{hotelKeyword}</OtaText>
              </OtaMeta>
            </OtaLink>
          ))}
        </OtaList>

        <QuickInfo>
          <InfoItem>
            <h4>
              50<span>+</span>
            </h4>
            <p>Comfortable Rooms</p>
          </InfoItem>
          <InfoItem>
            <h4>
              4.8<span>/5</span>
            </h4>
            <p>Guest Rating</p>
          </InfoItem>
          <InfoItem>
            <h4>
              24<span>/7</span>
            </h4>
            <p>Customer Support</p>
          </InfoItem>
        </QuickInfo>
      </BookingContainer>
    </BookingSection>
  );
};

export default BookingWidget;
